export default __webpack_public_path__ + "static/media/Celostrials_Logo.d745a35c.png";